import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-point-blank",
  "use": "icon-point-blank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-point-blank\"><path d=\"M514.926 1015.745c-276.848 0-502.027-225.266-502.027-502.053 0-276.846 225.179-502.055 502.027-502.055 276.817 0 502.053 225.21 502.053 502.055 0 276.787-225.236 502.053-502.053 502.053zm0-912.819c-226.479 0-410.748 184.284-410.748 410.763 0 226.45 184.27 410.777 410.748 410.777 226.508 0 410.777-184.326 410.777-410.777 0-226.479-184.269-410.763-410.777-410.763z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol